<template>
  <div class="animated fadeIn">
    
    <h4 class="mb-3">Onedio.* Overviews</h4>
    <b-row>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-info">
          <b-card-body class="mt-pb-0">
            <h4 id="traffic" class="card-title mb-0 text-center">Total Pageviews</h4>
          </b-card-body>
          <div v-if="loaderOverviews">
            <loader :loading="loading"></loader>
          </div>
          <div v-if="pieChartStatus">
            <pie-chart-pageview v-if="request" :renderData=renderCommand>
            </pie-chart-pageview>
          
          <b-card-body class="pb-0">
              <p class="h6 half-left"> onedio.com</p> <p class="h6 half-right">:  {{comPageView}} </p>
            <p class="h6 half-left"> onedio.co</p> <p class="h6 half-right"> : {{coPageView}} </p>
            <p class="h6 half-left"> onedio.ru</p> <p class="h6 half-right"> : {{ruPageView}} </p>
            <div class="text-right">Last {{filterDates.length}} Days</div>
          </b-card-body>
          </div>
          <b-card-body class="pb-0">
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-info">
          <b-card-body class="mt-pb-0">
            <h4 id="traffic" class="card-title mb-0 text-center">Total Session</h4>
          </b-card-body>
          <div v-if="loaderOverviews">
            <loader :loading="loading"></loader>
          </div>
          <div v-if="pieChartStatus">
          <pie-chart-session v-if="request" :renderData=renderCommand >
            </pie-chart-session>
          
          <b-card-body class="pb-0">
           <p class="h6  half-left"> onedio.com</p> <p class="h6 half-right">: {{comSession}} </p>
            <p class="h6 half-left"> onedio.co</p> <p class="h6 half-right"> : {{coSession}} </p>
            <p class="h6 half-left"> onedio.ru</p> <p class="h6 half-right"> : {{ruSession}} </p>
            <div class="text-right">Last {{filterDates.length}} Days</div>
          </b-card-body>
          </div>
          <b-card-body class="pb-0">
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-info">
          <b-card-body class="mt-pb-0">
            <h4 id="traffic" class="card-title mb-0 text-center">Total Users</h4>
          </b-card-body>
          <div v-if="loaderOverviews">
            <loader :loading="loading"></loader>
          </div>
          <div v-if="pieChartStatus">
          <pie-chart-user v-if="request" :renderData=renderCommand >
            </pie-chart-user>
          
          <b-card-body class="pb-0">
            <p class="h6 half-left"> onedio.com </p> <p class="h6 half-right">: {{comUsers}} </p>
            <p class="h6 half-left"> onedio.co </p> <p class="h6 half-right"> : {{coUsers}} </p>
            <p class="h6 half-left"> onedio.ru </p> <p class="h6 half-right"> : {{ruUsers}} </p>
            <div class="text-right">Last {{filterDates.length}} Days</div>
          </b-card-body>
          </div>
          <b-card-body class="pb-0">
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-info">
          <b-card-body class="mt-pb-0">
            <h4 id="traffic" class="card-title mb-0 text-center">Avg. Bounce Rate</h4>
            </b-card-body>
          <div v-if="loaderOverviews">
            <loader :loading="loading"></loader>
          </div>
          <div v-if="pieChartStatus">
          <pie-chart-rate v-if="request" :renderData=renderCommand >
            </pie-chart-rate>
          
          <b-card-body class="pb-0">
            <p class="h6 half-left"> onedio.com</p> <p class="h6 half-right">: {{comRates}} </p>
            <p class="h6 half-left"> onedio.co </p> <p class="h6 half-right"> : {{coRates}} </p>
            <p class="h6 half-left"> onedio.ru </p> <p class="h6 half-right"> : {{ruRates}} </p>
            <div class="text-right">Last {{filterDates.length}} Days</div>
          </b-card-body>
          </div>
          <b-card-body class="pb-0">
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <div>
      
      <b-card>
        <div>
          <b-row>
            <b-col sm="6">
              <h4 id="traffic" class="card-title mb-0">Total Datas</h4>
            </b-col>
            <b-col sm="6">
              <h4 id="traffic" class="card-title mb-0" v-if="overviewSelected === 'pageview'">  Total Pageview : {{generalTotal}}K ({{filterDates.length}} days)  </h4>
              <h4 id="traffic" class="card-title mb-0" v-else-if="overviewSelected === 'user'">  Total Users : {{generalTotal}}K ({{filterDates.length}} days)  </h4>
              <h4 id="traffic" class="card-title mb-0" v-else-if="overviewSelected === 'session'"> Total Sessions : {{generalTotal}}K ({{filterDates.length}} days) </h4>
              <h4 id="traffic" class="card-title mb-0" v-else-if="overviewSelected === 'bounce_rate'">  Avg. Bounce Rate : {{generalTotal}}% ({{filterDates.length}} days) </h4>
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col sm="3">
              <label for="month1">Overviews</label>
             <b-form-select id="month1"  v-model="overviewSelected" :plain="true" :options="overviewOptions">
              </b-form-select>
            </b-col>
            <b-col sm="3">
              <label for="month1">Sites</label>
              <v-select :on-change="change" v-model="siteSelected" :multiple=true :options="sitesSelected"></v-select>
            </b-col>
          </b-row>
          <div v-if="loaderStatus">
            <loader :loading="loading"></loader>
          </div>
          <div v-if="chartStatus">
            <overview-chart chartId="main-chart-01" class="chart-wrapper"
              style="height:300px;margin-top:40px;" :renderData=renderCommand height="300" ></overview-chart>
          </div>
        </div>
      </b-card>
    </div>
   <!--  <b-card>
      <data-table :renderData=renderCommand :selectedSites=siteSelected :selectedServices=optionSelected />
    </b-card> -->
  </div>
</template>

<script>
  import CardBarChartExample from './dashboard/CardBarChartExample'
  import BarBouncerate from './dashboard/BarBouncerate'
  import JWT from 'jsonwebtoken'
  import loader from 'vue-spinner/src/PulseLoader'
  import VueHotelDatepicker from '@northwalker/vue-hotel-datepicker'
  import Dateformatter from '../plugins/dateFormatter'
  import {
    parse
  } from 'path'
  import numeral from 'numeral'
  import DataTable from './base/Tables'
  import PieChartUser from '../views/charts/PieChartUser'
  import PieChartPageview from '../views/charts/PieChartPageview'
  import PieChartSession from '../views/charts/PieChartSession'
  import dateFormatter from '../plugins/dateFormatter'
  import PieChartRate from '../views/charts/PieChartRate';
  import format from 'date-fns/format'
  import OverviewChart from '../views/OverviewChart'
  export default {
    name: 'dashboard',
    props:['setData'],
    components: {
      CardBarChartExample,
      DataTable,
      loader,
      VueHotelDatepicker,
      PieChartUser,
      PieChartPageview,
      PieChartSession,
      PieChartRate,
      OverviewChart
    },
    data: function () {
      return {
        overviewOptions:[{text:'Pageview', value:'pageview'},
                {text:'Session', value:'session'},
                {text:'User',value:'user'},
                {text:'Bounce Rate',value:'bounce_rate'},],
        overviewSelected:'pageview',
        isloading: false,
        pageView: 0,
        session: 0,
        users: 0,
        rates:0,
        comUsers:0,
        comPageView:0,
        comSession:0,
        comRates:0,
        coUsers:0,
        coPageView:0,
        coSession:0,
        coRates:0,
        ruUsers:0,
        ruPageView:0,
        ruSession:0,
        ruRates:0,
        renderCommand: 0,
        loading: true,
        chartStatus: false,
        loaderStatus: true,
        filterDates:[],
        loaderOverviews:true,
        pieChartStatus:false,
        minDate: '2018/8/7',
        startDate: '2018/8/7',
        endDate: '',
        sitesSelected: ['onediocom', 'onedioru', 'onedioco'],
        siteSelected: ['onediocom'],
        request: false,
        generalTotal: 0,
      }
    },
    
    methods: {
      async change(e) {
        let overview=this.overviewSelected
        this.siteSelected=this.$store.state.selectedSites
        let site = this.siteSelected
        await this.$store.dispatch('OVERVIEW_CHART',{overview,site})
        await this.renderCommand++;        
      /*  setTimeout(async () => { */
        /*  this.loaderStatus = false
          this.chartStatus = true */
          /* this.generalTotal = await this.$store.state.generalTotal.toFixed(2) */
          this.$events.listen('SET_GENERAL_TOTAL_OVERVIEW', generalTotal => {
                  this.generalTotal=generalTotal.toFixed(2)
                });
         /*  this.filterDates=await this.$store.state.mainOverviewsData.filterDates */
         await this.$events.listen('SET_DATES',dates => {
           this.filterDates=dates
         })
       /*  }, 1000);  */
      },
      async setChartData(){
      this.chartStatus = await false,
      this.loaderStatus = await true,
      this.pieChartStatus=await false
      this.loaderOverviews=await true
     /*  setTimeout(async () => { */
        await this.renderCommand++;
        let site = this.siteSelected
        let overview=this.overviewSelected
        if(this.$store.state.mainOverviewsData){
          if(this.$store.state.mainOverviewsData.datas){
            if(this.$store.state.mainOverviewsData.datas[0]){
              this.chartData = await this.$store.state.mainOverviewsData.datas[0]
              await this.setOverview(this.chartData.onediocomDatas,"onedio.com")
              await this.setOverview(this.chartData.onediocoDatas,"onedio.co")
              await this.setOverview(this.chartData.onedioruDatas,"onedio.ru")
            }
          }
        }
         await this.$store.dispatch('OVERVIEW_CHART',{overview,site})
         /* this.generalTotal = await this.$store.state.generalTotal.toFixed(2)  */
         await this.$events.listen('SET_GENERAL_TOTAL_OVERVIEW', generalTotal => {
                  this.generalTotal=generalTotal.toFixed(2)
                });
         /* this.filterDates=await this.$store.state.mainOverviewsData.filterDates */
         await this.$events.listen('SET_DATES',dates => {
           this.filterDates=dates
         })
      this.chartStatus = await true
      this.loaderStatus = await false
      this.pieChartStatus=await true
      this.loaderOverviews=await false

      /* }, 500); */
    },
    async setOverview(overviewData, siteName){
      /* this.filterDates=await this.$store.state.mainOverviewsData.filterDates */
      await this.$events.listen('SET_DATES',dates => {
           this.filterDates=dates
         })
      this.pageView=0
      this.session=0
      this.users=0
      this.rates=0
      overviewData.forEach(element => {
          this.pageView += parseInt(element.pageviews);
          this.session += parseInt(element.session);
          this.users += parseInt(element.users);
          this.rates+= parseFloat(element.bounce_rate)
        });
      let viewCount = numeral(this.pageView)
      this.pageView = viewCount.format().replace(/,/g, '.')
      viewCount = numeral(this.session)
      this.session = viewCount.format().replace(/,/g, '.')
      viewCount = numeral(this.users)
      this.users = viewCount.format().replace(/,/g, '.')
      viewCount=numeral(this.rates)
      let user=this.users
      let session=this.session
      let pageview=this.pageView
      let rate=this.rates
      if(this.filterDates){
        rate=rate/(this.filterDates.length)
      }
      
      rate=rate.toFixed(2)
      if(siteName === "onedio.com"){
        this.comUsers=this.users
        this.comPageView=this.pageView
        this.comSession=this.session
        this.comRates=rate
        await this.$store.dispatch('SET_ONEDIOCOM_OVERVIEWS', {
          user,
          pageview,
          session,
          rate
        })
      }
      else if(siteName==="onedio.co"){
        this.coUsers=this.users
        this.coPageView=this.pageView
        this.coSession=this.session
        this.coRates=rate
        await this.$store.dispatch('SET_ONEDIOCO_OVERVIEWS', {
         user,
          pageview,
          session,
          rate
        })
      }
      else if(siteName==="onedio.ru"){
        this.ruUsers=this.users
        this.ruPageView=this.pageView
        this.ruSession=this.session
        this.ruRates=rate
        await this.$store.dispatch('SET_ONEDIORU_OVERVIEWS', {
         user,
          pageview,
          session,
          rate
        })
      }
      this.request=this.$store.state.request
    }
    }
    , 
    beforeCreate() {
      const token = $cookies.get('user')
      if (token) {
        JWT.verify(token, this.$store.state.jwtToken, (err, decode) => {
          if (err) {
            this.$router.push('/pages/login')
          }else this.$store.dispatch('SET_REQUEST', true)
        })
      } else this.$router.push('/pages/login')
    },
    async created() {
      if(this.$store.state.request){
        let site = this.$store.state.selectedSites
        if(!site.length){
          site=this.siteSelected
        }
        let overview=this.overviewSelected
        await this.$store.dispatch('OVERVIEW_CHART',{overview,site})
        if(!this.$store.state.mainOverviewsData['filterDates']){
          await this.$store.dispatch('MAIN_OVERVIEWS_WEEKLY_DATA')
          await this.$events.fire('SET_DATES',this.$store.state.mainOverviewsData.filterDates)
        }
        else{
          this.filterDates=await this.$store.state.mainOverviewsData.filterDates
        }
        /* this.generalTotal = await this.$store.state.generalTotal.toFixed(2) */
        await this.$events.listen('SET_GENERAL_TOTAL', generalTotal => {
                  this.generalTotal=generalTotal.toFixed(2)
                });
                 await this.setChartData()
        /* this.filterDates=this.$store.state.mainOverviewsData.filterDates */
      }
    }, 
     async mounted() {
      numeral.defaultFormat('0,0');
      this.filterDates=[]
      /* setTimeout(async () => { */
        this.request=this.$store.state.request
       if(this.request){
          //get overviews data
        this.chartData = await this.$store.state.mainOverviewsData.datas[0]
        await this.setOverview(this.chartData.onediocomDatas,"onedio.com")
        await this.setOverview(this.chartData.onediocoDatas,"onedio.co")
        await this.setOverview(this.chartData.onedioruDatas,"onedio.ru")
        }
     /*  }, 3000);
      setTimeout( async() => { */
        await this.setChartData()
       /*  }, 2000);
        setTimeout( async() => { */
        if(!this.filterDates.length){
          await this.$events.listen('SET_DATES',dates => {
           this.filterDates=dates
         })
        this.filterDates=[... new Set(this.filterDates)]
        }
        else{
          this.filterDates=[... new Set(this.$store.state.mainOverviewsData.filterDates)]
        }

        
          /* this.filterDates=[... new Set(this.$store.state.mainOverviewsData.filterDates)] */
          
          /* this.generalTotal = await this.$store.state.generalTotal.toFixed(2) */
       /*  },2000); */
        await this.$events.listen('SET_GENERAL_TOTAL', generalTotal => {
                  this.generalTotal=generalTotal.toFixed(2)
                });
        
    },  
    watch: {
      async setData(nValue,oValue){
        this.setChartData()
       
      },
      overviewSelected(nValue,oValue){
        this.change()
      }
    },
  }
</script>

<style scoped>
  #datepicker-trigger{
    width: 250px;
  }
  .half-left{
    width: 50%;
    float: left;
    text-align:right;
  }
  .half-right{
    width: 50%;
    float: left;
    text-align:left;
  }
  .loader{
    color: '#000000'
    
  }

</style>